import moment from 'moment'
import React, { useState } from 'react'
import { Link, Route, Switch, useHistory } from 'react-router-dom'
import { DatePicker, Menu, Dropdown, Badge } from 'antd'
import Select from "react-select"

import { FaHandHolding } from 'react-icons/fa'
import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet, useSocketEvents, pharmacyStatus, presets, useShift } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'
import InpatientBadge from '../../components/reusable/inpatientBadge'

import WalkIn from '../../components/modals/walkIn'

import PatientDetails from '../../components/drawers/patient'
import SentMedication from '../../components/drawers/sentMedication'
import Store from '../../components/drawers/store'
import ItemRequests from '../../components/drawers/itemRequests'
import CallForPatient from '../../components/reusable/callForPatient'
import { useSelector } from 'react-redux'

const { RangePicker } = DatePicker

const Prescriptions = () => {
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [chosen, setChosen] = useState([])
    const [string, setString] = useState('')
    const [status, setStatus] = useState({ label: 'All', value: 'All' })
    const [group, setGroup] = useState([])
    const [pendingForwards, setFCount] = useState(0)
    const [stores, setStores] = useState([])
    const [requests, setRequests] = useState(0)
    const [store, setStore] = useState()
    const [cId, setCId] = useState()

    const history = useHistory()

    const { shift } = useSelector(state => state.application)

    const [Shifts, ShiftsModal] = useShift('Pharmacy')
    
    const [select, toggleSelect] = useToggle()
    const [walkIn, toggleWalkIn] = useToggle()

    usePet('medicationGroup', null, { notify: false, callback: ({ data }) => setGroup(data) })

    const [, getRequests] = usePet('requestsByStore', { store: store?._id, type: "Received", classif: 'Pending' }, { notify: true, manual: true, callback: ({ data }) => setRequests(data.count) })

    const [
        { loading: qLoading, error: qError, fetch: fetchBillItems },
        { list: queue },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('pharmacyRequests', ranges ? { 
        status: status?.value,
        string, 
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null
    } : { status: status?.value, string }, { notify: true }, 'orders')

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = resetNav => {
        if (resetNav)
            navigate(1)

        getRequests()
        fetchBillItems()
    }    
    
    usePet('getStoreId', { name: 'Pharmacy' }, { notify: true, callback: ({ data }) => {
        if (data) {
            setStore(data)
            refresh()
        }
    } })

    useSocketEvents({
        'new-patient': {
            condition: data => data.destination === 'Pharmacy',
            notif: {
                message: 'New Patient',
                type: 'info'
            },
            callback: refresh
        },
        'new-request': {
            condition: data => data.store === 'Pharmacy',
            notif: {
                message: 'New Request',
                type: 'info'
            },
            callback: getRequests
        }
    })

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const changeStatus = stat => {
        setStatus(stat)
        refresh()
    }

    const sendWalkIn = patient => {
        toggleWalkIn()
        history.push(`/app/pharmacy/prescriptions/${patient._id}`)
    }

    const onSComplete = (_, notif, ops) => {
        refresh()
        notif('Changes have been saved', ops('success'))
    }

    const [{ loading: sLoading }, toggleSeen] = usePet('toggleSeenStatus', { 
        id: cId
    }, { notify: true, callback: onSComplete, manual: true })

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Modals */}
            {
                walkIn &&
                <WalkIn
                    visible={ walkIn }
                    toggle={ toggleWalkIn }
                    onPerform={ sendWalkIn } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker value={ ranges } onChange={selectRange} ranges={ presets } />
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                    <Shifts />
                </div>
            </div>
            { ShiftsModal }
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800 mb-1">Patients' Queue</h2>
                    <span className="flex items-center justify-between">
                        <Select
                            value={status}
                            onChange={changeStatus}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={ ['All', 'Seen', 'Pending', 'Paid'].map(stat => ({ label: stat, value: stat }))}
                            placeholder="Select Status" />
                        {
                            shift &&
                            <button onClick={ toggleWalkIn } className="btn hisani-btn-green-light ml-2 text-white">
                                <span className="xs:block">Walk-In</span>
                            </button>
                        }
                        <button onClick={refresh} className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={qLoading}
                        error={qError}>
                        {
                            queue?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Items</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Sent On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                queue.map((order, key) => {
                                                    let status = pharmacyStatus(order, group)
                                                    return (
                                                        <tr>
                                                            <td className="p-2">
                                                                <div className="text-center">
                                                                    {
                                                                        select ?
                                                                            <input
                                                                                onChange={() => choose(order._id)}
                                                                                checked={chosen.includes(order._id)}
                                                                                type="checkbox"
                                                                                className="form-checkbox cursor-pointer h-5 w-5" />
                                                                            :
                                                                            `${((page - 1) * limit) + (key + 1)}.`
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td className="p-2">
                                                                <Patient patient={ order?.patient } />
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="text-left">{ order?.items?.filter(item => group?.categories?.indexOf(item?.ref?.category) >= 0)?.length ?? 0 }</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className="text-center">{stringifyDate(order.date)}</div>
                                                            </td>
                                                            <td className="p-2">
                                                                <div className={ `text-${ status.colour}-500` }>{ status.main } ({ status.status })</div>
                                                            </td>
                                                            <td className="p-2 text-center">
                                                                <InpatientBadge show={ order.inPatient }>
                                                                    <div className="text-center">
                                                                        <Dropdown
                                                                            overlay={
                                                                                <Menu>
                                                                                    <Link to={ `/app/pharmacy/prescriptions/${order._id}` }><Menu.Item>{ order.filled ? 'Review' : 'View' } Request</Menu.Item></Link>
                                                                                    <Link to={ `/app/pharmacy/prescriptions/patients/${order.patient?._id}` }><Menu.Item>Patient Details</Menu.Item></Link>
                                                                                    <Menu.Item onClick={ () => null }>Forward Patient</Menu.Item>
                                                                                    { 
                                                                                        shift && 
                                                                                        <>
                                                                                            <CallForPatient order={ order?._id } />
                                                                                            {
                                                                                                !order.filled &&
                                                                                                <Menu.Item onClick={ () => null }>{ order.discarded ? 'Restore' : 'Discard' }</Menu.Item>
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                    {/* {
                                                                                        (item?.seen || item?.served) &&
                                                                                        <Menu.Item onClick={ () => {
                                                                                            setCId(item?._id)
                                                                                            Confirm({
                                                                                                title: 'Mark Item as Unseen?',
                                                                                                message: 'This will revert the selected item back to the pending queue',
                                                                                                okText: 'Mark as Unseen',
                                                                                                onOk: toggleSeen
                                                                                            })
                                                                                        } }>Mark as Unseen</Menu.Item>
                                                                                    } */}
                                                                                </Menu>
                                                                            }>
                                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                        </Dropdown>
                                                                    </div>
                                                                </InpatientBadge>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No patients { string.trim().length > 2 ? `matching "${string}"` : "" } were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route path="/app/pharmacy/prescriptions/patients/:id">
                    <PatientDetails reload={ () => refresh(false) } source="/app/pharmacy" />
                </Route>
                <Route path="/app/pharmacy/prescriptions/:id">
                    <SentMedication source="/app/pharmacy/prescriptions" onPerform={ () => refresh(false) } />
                </Route>
            </Switch>
        </div>       
    )
}

export default Prescriptions